(function () {
  class CardsSlider {
    constructor(section) {
      this.section = section;
      this.autoplay = this.section.dataset.autoplay === 'true';
      this.videoItems = this.section.querySelectorAll('[data-video-item]');
      this.observers = [];
      this.initSwiper();
      this.initTapControls();

      if (this.autoplay) {
        this.initAutoplay();
      }
    }

    initSwiper() {
      const sliderEl = this.section.querySelector('[data-cards-slider]');
      if (!sliderEl || typeof Swiper === 'undefined') return;
      
      const slides = sliderEl.querySelectorAll('.swiper-slide');
      if (!slides.length) return;

      new Swiper(sliderEl, {
        slidesPerView: 1.3,
        spaceBetween: 16,
        touchEventsTarget: 'container',
        breakpoints: {
          768: {
            slidesPerView: 2.3,
            spaceBetween: 20
          },
          1280: {
            slidesPerView: 3.2,
            spaceBetween: 24
          }
        }
      });
    }

    initTapControls() {
      this.section.querySelectorAll('[data-video-tap-overlay]').forEach(overlay => {
        const video = overlay.closest('[data-video-item]').querySelector('video');
        if (!video) return;

        overlay.addEventListener('click', () => {
          if (video.paused) {
            video.play().catch(err => console.log('Play prevented:', err));
          } else {
            video.pause();
          }
        });

        video.addEventListener('play', () => overlay.classList.remove('is-paused'));
        video.addEventListener('pause', () => overlay.classList.add('is-paused'));
        video.addEventListener('ended', () => overlay.classList.add('is-paused'));
      });
    }

    initAutoplay() {
      const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.75
      };

      this.videoItems.forEach(item => {
        const video = item.querySelector('video');
        const iframe = item.querySelector('iframe');
        
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.75) {
              this.playVideo(video, iframe);
            } else {
              this.pauseVideo(video, iframe);
            }
          });
        }, observerOptions);

        observer.observe(item);
        this.observers.push(observer);
      });
    }

    playVideo(video, iframe) {
      if (video) {
        video.play().catch(err => {
          console.log('Video autoplay prevented:', err);
        });
      } else if (iframe) {
        const src = iframe.src;
        if (src.includes('youtube.com')) {
          iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        } else if (src.includes('vimeo.com')) {
          iframe.contentWindow.postMessage('{"method":"play"}', '*');
        }
      }
    }

    pauseVideo(video, iframe) {
      if (video) {
        video.pause();
      } else if (iframe) {
        const src = iframe.src;
        if (src.includes('youtube.com')) {
          iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        } else if (src.includes('vimeo.com')) {
          iframe.contentWindow.postMessage('{"method":"pause"}', '*');
        }
      }
    }

    destroy() {
      this.observers.forEach(observer => observer.disconnect());
    }
  }

  function getHandleFromCountry(country) {
    if (country === 'PT') return 'kencko.pt';
    if (country === 'ES') return 'kencko.es';
    if (country === 'FR') return 'kencko.fr';
    if (country === 'GB' || country === 'UK') return 'kencko.uk';
    return 'kencko';
  }

  function getHandleFromLocale(locale) {
    if (locale === 'pt') return 'kencko.pt';
    if (locale === 'es') return 'kencko.es';
    if (locale === 'fr') return 'kencko.fr';
    return 'kencko';
  }

  function setInstagramHandle(handleEl, handle) {
    handleEl.textContent = '@' + handle;
    handleEl.href = 'https://www.instagram.com/' + handle + '/';
  }

  function updateSectionInstagramHandle(section) {
    const handleEl = section.querySelector('[data-geo-handle]');
    if (!handleEl) return Promise.resolve();

    const hostname = window.location.hostname.toLowerCase();
    const pathLocale = window.location.pathname.split('/')[1].toLowerCase();
    const localeHandle = (pathLocale === 'pt' || pathLocale === 'es' || pathLocale === 'fr') ? pathLocale : '';

    if (hostname.includes('kencko.eu') && localeHandle) {
      setInstagramHandle(handleEl, getHandleFromLocale(localeHandle));
      return Promise.resolve();
    }

    return fetch('https://ipapi.co/json/')
      .then(function (res) {
        if (!res.ok) throw new Error('Geo lookup failed');
        return res.json();
      })
      .then(function (data) {
        var country = (data.country_code || '').toUpperCase();
        setInstagramHandle(handleEl, getHandleFromCountry(country));
      })
      .catch(function () {
        setInstagramHandle(handleEl, 'kencko');
      });
  }

  function initCardsSliders() {
    const sections = document.querySelectorAll('.section-cards-slider');
    sections.forEach(section => {
      updateSectionInstagramHandle(section).finally(() => {
        new CardsSlider(section);
      });
    });
  }

  function waitForSwiperThenInit() {
    if (typeof Swiper !== 'undefined') {
      initCardsSliders();
      return;
    }
    // Swiper is loaded dynamically — wait for its script tag to finish
    const swiperScript = document.querySelector('script[src*="swiper"]');
    if (swiperScript) {
      swiperScript.addEventListener('load', initCardsSliders, { once: true });
    } else {
      // Script not yet injected; poll briefly
      let attempts = 0;
      const interval = setInterval(() => {
        if (typeof Swiper !== 'undefined') {
          clearInterval(interval);
          initCardsSliders();
        } else if (++attempts > 50) {
          clearInterval(interval);
        }
      }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForSwiperThenInit);
  } else {
    waitForSwiperThenInit();
  }

  document.addEventListener('shopify:section:load', () => {
    if (typeof Swiper !== 'undefined') {
      initCardsSliders();
    } else {
      waitForSwiperThenInit();
    }
  });
})();
